/* tslint:disable */
/* eslint-disable */
/**
 * PaGu Api
 * Gutschrifterstellung API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ConstructionServiceRequest } from '../models';
// @ts-ignore
import type { GetOrderIdsResponse } from '../models';
// @ts-ignore
import type { GetOrderResponse } from '../models';
// @ts-ignore
import type { GetOrdersByIdsRequest } from '../models';
// @ts-ignore
import type { GetProcessedOrdersRequest } from '../models';
// @ts-ignore
import type { OrderSetClientRequest } from '../models';
// @ts-ignore
import type { ProblemDetails } from '../models';
// @ts-ignore
import type { ProcessedOrderResponsePagedListResponse } from '../models';
/**
 * OrderApi - axios parameter creator
 * @export
 */
export const OrderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {OrderSetClientRequest} [orderSetClientRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrderClientPut: async (orderSetClientRequest?: OrderSetClientRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/order/client`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderSetClientRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ConstructionServiceRequest} [constructionServiceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrderConstructionservicePut: async (constructionServiceRequest?: ConstructionServiceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/order/constructionservice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(constructionServiceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrderOrderIdGet: async (orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('apiV1OrderOrderIdGet', 'orderId', orderId)
            const localVarPath = `/api/v1/order/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetOrdersByIdsRequest} [getOrdersByIdsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrderPost: async (getOrdersByIdsRequest?: GetOrdersByIdsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getOrdersByIdsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetProcessedOrdersRequest} [getProcessedOrdersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrderProcessedPost: async (getProcessedOrdersRequest?: GetProcessedOrdersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/order/processed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getProcessedOrdersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderApi - functional programming interface
 * @export
 */
export const OrderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {OrderSetClientRequest} [orderSetClientRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OrderClientPut(orderSetClientRequest?: OrderSetClientRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OrderClientPut(orderSetClientRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.apiV1OrderClientPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ConstructionServiceRequest} [constructionServiceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OrderConstructionservicePut(constructionServiceRequest?: ConstructionServiceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OrderConstructionservicePut(constructionServiceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.apiV1OrderConstructionservicePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OrderOrderIdGet(orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OrderOrderIdGet(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.apiV1OrderOrderIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetOrdersByIdsRequest} [getOrdersByIdsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OrderPost(getOrdersByIdsRequest?: GetOrdersByIdsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrderIdsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OrderPost(getOrdersByIdsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.apiV1OrderPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetProcessedOrdersRequest} [getProcessedOrdersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OrderProcessedPost(getProcessedOrdersRequest?: GetProcessedOrdersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessedOrderResponsePagedListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OrderProcessedPost(getProcessedOrdersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.apiV1OrderProcessedPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderApi - factory interface
 * @export
 */
export const OrderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderApiFp(configuration)
    return {
        /**
         * 
         * @param {OrderSetClientRequest} [orderSetClientRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrderClientPut(orderSetClientRequest?: OrderSetClientRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1OrderClientPut(orderSetClientRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConstructionServiceRequest} [constructionServiceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrderConstructionservicePut(constructionServiceRequest?: ConstructionServiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1OrderConstructionservicePut(constructionServiceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrderOrderIdGet(orderId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetOrderResponse> {
            return localVarFp.apiV1OrderOrderIdGet(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetOrdersByIdsRequest} [getOrdersByIdsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrderPost(getOrdersByIdsRequest?: GetOrdersByIdsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetOrderIdsResponse> {
            return localVarFp.apiV1OrderPost(getOrdersByIdsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetProcessedOrdersRequest} [getProcessedOrdersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrderProcessedPost(getProcessedOrdersRequest?: GetProcessedOrdersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProcessedOrderResponsePagedListResponse> {
            return localVarFp.apiV1OrderProcessedPost(getProcessedOrdersRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderApi - interface
 * @export
 * @interface OrderApi
 */
export interface OrderApiInterface {
    /**
     * 
     * @param {OrderSetClientRequest} [orderSetClientRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApiInterface
     */
    apiV1OrderClientPut(orderSetClientRequest?: OrderSetClientRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {ConstructionServiceRequest} [constructionServiceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApiInterface
     */
    apiV1OrderConstructionservicePut(constructionServiceRequest?: ConstructionServiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {number} orderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApiInterface
     */
    apiV1OrderOrderIdGet(orderId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetOrderResponse>;

    /**
     * 
     * @param {GetOrdersByIdsRequest} [getOrdersByIdsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApiInterface
     */
    apiV1OrderPost(getOrdersByIdsRequest?: GetOrdersByIdsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetOrderIdsResponse>;

    /**
     * 
     * @param {GetProcessedOrdersRequest} [getProcessedOrdersRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApiInterface
     */
    apiV1OrderProcessedPost(getProcessedOrdersRequest?: GetProcessedOrdersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProcessedOrderResponsePagedListResponse>;

}

/**
 * OrderApi - object-oriented interface
 * @export
 * @class OrderApi
 * @extends {BaseAPI}
 */
export class OrderApi extends BaseAPI implements OrderApiInterface {
    /**
     * 
     * @param {OrderSetClientRequest} [orderSetClientRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public apiV1OrderClientPut(orderSetClientRequest?: OrderSetClientRequest, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).apiV1OrderClientPut(orderSetClientRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConstructionServiceRequest} [constructionServiceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public apiV1OrderConstructionservicePut(constructionServiceRequest?: ConstructionServiceRequest, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).apiV1OrderConstructionservicePut(constructionServiceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} orderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public apiV1OrderOrderIdGet(orderId: number, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).apiV1OrderOrderIdGet(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetOrdersByIdsRequest} [getOrdersByIdsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public apiV1OrderPost(getOrdersByIdsRequest?: GetOrdersByIdsRequest, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).apiV1OrderPost(getOrdersByIdsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetProcessedOrdersRequest} [getProcessedOrdersRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public apiV1OrderProcessedPost(getProcessedOrdersRequest?: GetProcessedOrdersRequest, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).apiV1OrderProcessedPost(getProcessedOrdersRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

